import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/checkout/payment-icons/svea.png")